import { Link } from "react-router-dom";
import { ReadingDateRow } from "./ReadingDateRow";
import { formatDate } from "@/lib/format";

const Section = ({ title, testId, children }) => (
  <section data-testid={testId} className="rounded-lg border bg-white">
    <h3 className="border-b px-4 py-2 text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</h3>
    {children}
  </section>
);

export const ReadingResult = ({ workspace, reading, onDateAdded }) => {
  const r = reading.result;
  return (
    <div className="space-y-4" data-testid="reading-result">
      <p className="text-xs text-slate-500" data-testid="reading-meta">Read {formatDate(reading.created_at)}{r.document_type ? ` · ${r.document_type}` : ""}{r.issuer ? ` · From ${r.issuer}` : ""}</p>
      <Section title="Plain-language summary" testId="reading-summary"><p className="whitespace-pre-wrap px-4 py-3 text-sm text-slate-700">{r.summary}</p></Section>
      <Section title="What the document asks for" testId="reading-actions">
        {r.requested_actions.length ? <ul className="divide-y">{r.requested_actions.map((a, i) => (
          <li key={i} className="px-4 py-3 text-sm text-slate-700">{a.what}{a.quote && <span className="mt-1 block border-l-2 border-gold pl-2 text-xs italic text-slate-500">"{a.quote}"</span>}</li>
        ))}</ul> : <p className="px-4 py-3 text-sm text-slate-500">No specific requests found.</p>}
      </Section>
      <Section title="Possible dates (unconfirmed)" testId="reading-dates">
        {r.dates.length ? <ul className="divide-y">{r.dates.map((d, i) => <ReadingDateRow key={i} workspace={workspace} reading={reading} d={d} index={i} onAdded={onDateAdded} />)}</ul>
          : <p className="px-4 py-3 text-sm text-slate-500">No dates found in the document text.</p>}
        {r.dropped_dates > 0 && <p className="px-4 pb-3 text-xs text-slate-500" data-testid="reading-dropped-dates">{r.dropped_dates} possible date(s) were left out because their wording couldn't be found in the document.</p>}
      </Section>
      <Section title="Verified forms that may relate" testId="reading-forms">
        {r.suggested_forms.length ? <ul className="divide-y">{r.suggested_forms.map((f) => (
          <li key={f.form_id} className="px-4 py-3 text-sm"><Link to={`/app/w/${workspace.id}/forms/${f.form_id}`} data-testid={`reading-form-link-${f.form_id}`} className="font-medium text-navy underline">{f.number}: {f.title}</Link>
            <p className="text-xs text-slate-500">{f.agency}. May relate: {f.reason}</p></li>
        ))}</ul> : <p className="px-4 py-3 text-sm text-slate-500">No matching form in EVR's verified library.</p>}
      </Section>
      {r.unclear.length > 0 && <Section title="Not clear from the document" testId="reading-unclear"><ul className="space-y-1 px-4 py-3 text-sm text-slate-700">{r.unclear.map((u) => <li key={u}>• {u}</li>)}</ul></Section>}
      {reading.truncated && <p className="text-xs text-amber-900" data-testid="reading-truncated">This document is long. Only the first part was read.</p>}
    </div>
  );
};
